<!--
 * @Author: cryi.liu
 * @Date: 2020-05-08 14:00:58
 * @LastEditTime: 2020-06-16 16:31:50
 * @Description: 创建新大题
 -->
<template>
  <div class="create-big-question">
    <big-question-overview type="empty" />
    <div class="placeholder">
      <p class="title"></p>
      <div class="wrap">
        <div class="create-btn">
          <i-icon type="ios-add" size="32" />
          <p>创建新大题</p>
        </div>
        <div class="select-type">
          <i-button
            v-for="type in selectType"
            :key="type.value"
            type="primary"
            @click="clickQuestionTypeBtnHandler(type)">{{ type.text }}</i-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BigQuestionOverview from './BigQuestionOverview.vue';

export default {
  name: 'CreateBig-question',
  components: {
    BigQuestionOverview,
  },
  data() {
    return {
      selectType: [
        { text: '单选题', value: '单选' },
        { text: '多选题', value: '多选' },
        { text: '不定项选择题', value: '不定项选择' },
        { text: '判断题', value: '判断' },
        { text: '填空题', value: '填空' },
        { text: '简答题', value: '简答' },
      ],
    };
  },
  computed: {
    ...mapGetters({
      addBigQuestionRule: 'createPaperStore/addBigQuestionRule',
    }),
  },
  methods: {
    ...mapActions({
      setAddQuestionByProductGroupModalType: 'createPaperStore/invokeSetAddQuestionByProductGroupModalType',
      setAddQuestionByProductCodeModalType: 'createPaperStore/invokeSetAddQuestionByProductCodeModalType',
      setAddBigQuestionRuleOfQuestionType: 'createPaperStore/invokeSetAddBigQuestionRuleOfQuestionType',
    }),
    /**
     * 点击题目类型按钮处理函数
     */
    clickQuestionTypeBtnHandler({ value }) {
      this.setAddBigQuestionRuleOfQuestionType({ questionType: value });
      this.$emit('click-question-type', 'add');
    },
  },
};
</script>

<style lang="less" scoped>
.create-big-question {
  width: 100%;
  display: flex;
  justify-content: flex-start;

  > .placeholder {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-left: 32px;
    border-radius: 4px;
    background-color: #fff;
    border: 1px solid #ddd;

    > .title {
      flex: 0 0 36px;
      width: 100%;
      height: 36px;
      border-bottom: 1px solid #ddd;
    }

    > .wrap {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;

      &:hover {
        > .create-btn {
          display: none;
        }

        > .select-type {
          display: block;
        }
      }

      > .create-btn {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 92px;
        height: 92px;
        border: 1px solid #ddd;
        border-radius: 4px;

        > p {
          font-size: 12px;
        }
      }

      > .select-type {
        display: none;

        > button {
          margin-right: 12px;

          &:last-of-type {
            margin-right: 0;
          }
        }
      }
    }
  }
}
</style>
